import apiSales from '../apiSales';

import { ParamsDataListaCotacaoAddService } from 'utils/typeServices';

export const GetListaCotacao = async (CPF_CNPJ: string) => {
    const token = localStorage.getItem('token');

    try {
        const { data } = await apiSales.get<Array<ParamsDataListaCotacaoAddService>>(`/Quote/v2/ListarCotacoes?CPF_CNPJ=${CPF_CNPJ}&CD_SISTEMA=4&CD_SISTEMA=5`, {
            headers: {
                'Authorization': 'Bearer ' + token,
            }
        });

        return data;
    } catch (error) {
        console.error('error', error);
        return null;
    }
}
